module.exports = __webpack_public_path__ + "images/academy.54cdd02d.png";